<script>
	import { onMount } from 'svelte';
	import { extent } from 'd3-array';
	import { scaleLinear, scaleLog, scaleOrdinal } from 'd3-scale';
	import { axisLeft, axisRight, axisTop, axisBottom } from 'd3-axis';
	import { geoAlbersUsa, geoMercator, geoPath } from 'd3-geo';
	import { legendColor } from 'd3-svg-legend';
	import { select, selectAll } from 'd3-selection';
	import { format } from 'd3-format'
	import { transition } from 'd3-transition'
	import { pastels } from '../helpers/colors.js'
   import usaalbers from "../helpers/USAGeoAlbers.js";
	import statehex from "../helpers/USStateHexbin.js";

	let d3 = {
		extent: extent,
		scaleLinear: scaleLinear,
		scaleOrdinal: scaleOrdinal,
		scaleLog: scaleLog,
		select: select,
		selectAll: selectAll,
		axisLeft: axisLeft,
		axisRight: axisRight,
		axisBottom: axisBottom,
		axisTop: axisTop,
		geoAlbersUsa: geoAlbersUsa,
		geoMercator: geoMercator,
		geoPath: geoPath,
		legendColor: legendColor,
		format: format
	}

	export let data = {data};
	export let data2 = {data2};
	// export let colour = {colour}
	export let width = {width};
	export let maptype = "geo";
	export let height = width * 0.5;
	export let colorscheme = ["red", "pink", "purple", "blue"];
	export let variable = {variable}
    export let activeLocation;

	let el;
	let svg;

	let geojson;
	let projection;

	let classNames = [
	"graph",
	"us-graph"
	];

	const getClassNames = () => {
	   return classNames.join(" ");
   }

	// console.log(
	// 	data.map(d => d[variable])
	// )


	if (maptype === "hex") {
		geojson = statehex;


		if(width < 500){
			projection = d3.geoMercator()
				.scale(width * 0.83)
				// .translate([1155, 600]);
				.translate([(width * 2), (height * 1.17)]);
		}
		else if(width <= 820){
				projection = d3.geoMercator()
					.scale(width * 0.83)
					// .translate([1155, 600]);
					.translate([(width * 2), (height * 1.55)]);
			}
		else{
			projection = d3.geoMercator()
				.scale(width * 0.83)
				.translate([(width * 2.005), (height * 1.4)]);
		}

	} else {
		geojson = usaalbers;
		projection = d3.geoAlbersUsa()
			.scale(width * 1.3)
			.translate([(width / 2), (height / 2)]);
	}


	let labelSize = d3.scaleLinear()
		.domain([250, 1000])
		.range([7, 12])

	let colorScale = d3.scaleOrdinal()
		.domain(data2.map(d => d[variable]))
		.range(colorscheme)


	const padding = { top: 0, right: 40, bottom: 40, left: 50 };

	const path = d3.geoPath()
		.projection(projection);

	onMount(generateMap);


	function resize() {
		({ width, height } = svg.getBoundingClientRect());
	}

	function generateMap() {

		colorScale.domain(d3.extent(Object.values(data2.map(d => parseFloat(d[variable])))))

		// let svg = d3.select(el).append("svg");

		let chartGraph = d3.select(el);

		let chartWrapper = chartGraph.select('.chart__graph')
								.attr("width", width)
								.attr("height", height)
								.attr("preserveAspectRatio", "xMinYMin meet")
   								.attr("viewBox", "0 0 " + width + " " + height);

		// let chartWrapper = chartGraph.select('.chart__graph')
		// 						.attr("width", width)
		// 						.attr("height", height)
								// .attr("preserveAspectRatio", "xMinYMin meet")
   								// .attr("viewBox", "0 0 " + width + " " + height);

		chartWrapper = chartWrapper.append("g")
						.attr("class", "country");
			// .attr("width", width)
			// .attr("height", height)

		chartWrapper.append("g")
      .selectAll("path")
            .data(geojson.features)
      .enter()
      .append("path")
            .attr("dx", "-.8em")
            .attr("dy", ".15em")
			.attr("class", function(d,i){

				let result = data2.filter(obj => {
					return obj.state === d.properties.name
				})[0]
				// console.log(result)
				return "state-"+result.Code;
			})
			// .attr("class", function(d,i){
			//
			// 	let result = data2.filter(obj => {
			// 		return obj.state === d.properties.name
			// 	})[0]
			// 	// console.log(result)
			// 	return "state-"+result.Code;
			// })
			// .attr("fill", colour)
          .attr("fill", function(d,i){
			  // console.log(d)
				 let result = data2.filter(obj => {
					 return obj.state === d.properties.name
				 })[0]
				 // let result = data;
				 // console.log(result.status )

              if(result.status === "Proposed"){
                  return "#e99f28";
              }
              else if(result.status === "Vetoed"){
                  return "#e27a7a";
              }
              else if(result.status === "Signed"){
                  return "#83afda";
              }
              else{
                  return "#F5ECEC";

              }


			 })
			     	.attr('fill-opacity',function(d,i){

                        return 1.0;

						  })
          .attr("d", path)
		  .attr("stroke-width", function(d,i){
			  let result = data.filter(obj => {
				  // if(obj.status === "Signed" || obj.status === "Proposed" || obj.status === "Vetoed" || obj.books_banned !== "N/A"){
				  // if(obj.status !== "None" || obj.books_banned !== "N/A"){


				  if(obj.status !== "None" ){
				 return obj.state === d.properties.name
			 }
			 })[0]


			 // console.log(result)
			 if (result) {
				 // console.log(result[variable])


				d3.select(this)
					.raise();
				return "5"


			 } else {
				 d3.select(this)
					 .lower();
				return "1"
			 }
		  })
          .attr("stroke",function(d,i){
			  let result = data.filter(obj => {
				  // console.log(obj)
				 // if(obj.status === "Signed" || obj.status === "Proposed" || obj.status === "Vetoed" || obj.books_banned !== "N/A"){
				 if(obj.status !== "None" ){

					 return obj.state === d.properties.name

				 }
			  })[0]

			  // console.log(result)
			  if (result ) {
				  // console.log(result.status)


				 d3.select(this)
					 .raise();

				 return "#D41B2C";
			  } else {
				  // d3.selectAll("path").on("click", null)
				  // d3.select('.state').on('click', null)
				 return "#323131"
			  }
		  });
// console.log(data[0].state);
// return colorScgale(result[variable])

// let stateSelector = document.querySelectorAll('state');
//
// stateSelector.addEventListener('click',activeLocation);
// d3.selectAll(".state").on("click",activeLocation);


d3.selectAll("path").on("click", activateLocation);

// d3.select(".state-None").on("click", null);
//
d3.select(".state-HI").style("cursor", "default").on("click", null);
d3.select(".state-CA").style("cursor", "default").on("click", null);
d3.select(".state-NV").style("cursor", "default").on("click", null);
d3.select(".state-DC").style("cursor", "default").on("click", null);
d3.select(".state-MD").style("cursor", "default").on("click", null);
d3.select(".state-DE").style("cursor", "default").on("click", null);
d3.select(".state-VT").style("cursor", "default").on("click", null);
d3.select(".state-MA").style("cursor", "default").on("click", null);
d3.select(".state-CT").style("cursor", "default").on("click", null);
d3.select(".state-WY").style("cursor", "default").on("click", null);
d3.select(".state-NV").style("cursor", "default").on("click", null);
d3.select(".state-OR").style("cursor", "default").on("click", null);
d3.select(".state-CO").style("cursor", "default").on("click", null);
d3.select(".state-IL").style("cursor", "default").on("click", null);
d3.select(".state-KS").style("cursor", "default").on("click", null);
		  //
		      function activateLocation(event,d){
				  // console.log(event.currentTarget.properties)
				  // console.log(d.properties.name)

				  let result = data.filter(obj => {
					  if(obj.status === "Signed" || obj.status === "Proposed" || obj.status === "Vetoed" || obj.books_banned !== "N/A"){
				  return obj.state === d.properties.name
			  }
			  })[0]




					activeLocation = d.properties.name;

			  // cons
				  // console.log(d.properties.name);

				  // let result = data.filter(obj => {
					//   // console.log(obj)
				 	//  return obj.state === d.properties.name
				  // })[0]
				  // console.log(result);

				  // d3.select(".state")
					//   .selectAll("#pink,#violet")

				  // let result = data.filter(d.properties.name)[0]

            // Visually indicates the selected location on the map.
		    // if (!d3.select(event.currentTarget).classed("selected") ) {
			// 	d3.selectAll(".state")
			// 	.style("stroke", "black")
			// .style('stroke-width', "1")
			// .classed("selected",false);
			//
			//
			//
			// d3.select(event.currentTarget)
			// 	  .raise()
			// 	// .style("fill","gold")
			//   .style("stroke", "#D41B2C")
			//   .style('stroke-width', "5")
			//
			// 	  .classed("selected",true);
			// 	  // console.log("clicked")
			//
			//
			//
		    // 	 // d3.select(this)
			// 	 // 	.style("stroke", "black")
			// 	 // 	.style('stroke-width', "1")
		    // 		//  console.log("unclicked")
			//
		    // }
		    // else {
		    // 	d3.select(event.currentTarget)
			// 	.style("stroke", "black")
			// 	.style('stroke-width', "1")
		    // 		.classed("selected",false);
		    // 		console.log("clicked")
			//
		    // }

            // Changes the active item in the select box to the selected location.

            // Updates the view to reflect the data for the selected location.
		    }



	  // Add the labels
	  if (maptype === "hex") {
		  chartWrapper.append("g")
   	      .selectAll("labels")
   	      .data(geojson.features)
   	      .enter()
   	      .append("text")
   	        .attr("x", function(d){return path.centroid(d)[0]})
   	        .attr("y", function(d){return path.centroid(d)[1]})
  			.attr("class", "hex-text")
   	        .text(function(d){ return d.properties.postalcode})
   	        // .attr("text-anchor", "middle")
   	        // .attr("alignment-baseline", "central")
   	        // .style("font-size", labelSize(width))
   	        // .style("fill", function(d){
    		// 		 return "#000"
    		// 	 })
	  }



	   // add the tooltip
	   // let tooltip = d3.select(el).append("div")
		// 	.attr("class", "tooltip")
	   //
		// tooltip.append("span")
		// 	.attr("class", "line1")
		// 	.text("TESTING")
	   //
		// tooltip.append("span")
		// 	.attr("class", "line2")
		// 	.text("x")


		// const legend = d3.legendColor()
		// 	.scale(colorScale)
		// 	// .labels(function(d,i){
		// 	// 	for (let j=0; j<d.generatedLabels.length; j++) {
		// 	// 		d.generatedLabels[j] = (parseFloat(d.generatedLabels[j]) + "%")
		// 	// 	}
		// 	// 	return d.generatedLabels[d.i]
		// 	// })
		// 	.orient("horizontal")
		// 	.shapeWidth((width-25)/colorScale.domain().length)
		// 	.shapePadding(0)
		// 	.labelWrap(130)
		//
		// const legendContainer = d3.select(el).append("svg")
		// 	.attr("width", width-25)
		// 	.attr("class","legendContainer")
		// 	.attr("height", 40)
		// 	.append("g")
		// 	.attr("transform", "translate(0,0)")
		// 	.call(legend)







	}

	generateMap();

	      window.addEventListener("resize", generateMap);
</script>

<style>
	:global(.legendContainer) {
		font-family:"akkurat", sans-serif
	}
	/* :global(div.tooltip) {
		background-color:rgba(0,0,0,0.7);
		display:inline-block;
		padding:8px;
		border-radius:3px;
		color: #fff;
		text-align:center;
		position:absolute;
		visibility:hidden;
		width:200px;
		height:60px;
	}

	:global(div.tooltip .line1) {
		display:block;
		font-weight:bold;
		font-size:1.1rem;
		margin:0;
	}

	:global(div.tooltip .line2) {
		display:block;
		font-size:0.9rem;
		line-height: 1.1;
		margin:0;
	} */

:global(text.hex-text){
		/* fill: #d51e2d; */

		     pointer-events: none;
			 font-size: 25px;
			 text-anchor: middle;
			  dominant-baseline: middle;
		  	}

			:global(svg) {
		width: 100%;
		height: 100%;
		float: center;
cursor: pointer;
	}

	svg

	figure.graph{
		margin: 40px;
	}

	/* :global(svg g text.label) {
		text-transform: uppercase;
		fill: #666;
		font-size:11px;
	} */

	@media only screen and (max-width: 900px) {

		:global(text.hex-text){
				 font-size: 20px;
		}

		figure.graph{
			margin: 20px;
		}

	}

	@media only screen and (max-width: 600px) {

		:global(text.hex-text){
				 font-size: 12px;
		}

		figure.graph{
			margin: 5px;
		}


		/* figure.graph{
			height: 500px;
		} */
	}
	/* .chart :global(.state:nth-child(1))  {
		transform: scale(0.995);
	} */
</style>

<!-- <div bind:this={el} class="chart"></div> -->

<figure bind:this={el} class="{getClassNames()}">
<svg class = "chart__graph" bind:this={svg}></svg>

</figure>
